export function countryFlag(code: string): string {
  return [...code.toUpperCase()].map((c) => String.fromCodePoint(c.charCodeAt(0) + 127397)).join('');
}

export function initialsOf(name: string | null | undefined) {
  return (name ?? '').split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase();
}

function yearOf(iso: string | null): number | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d.getFullYear();
}

export function formatYearRange(start: string | null, end: string | null): string | null {
  const s = yearOf(start);
  const e = yearOf(end);
  if (!s && !e) return null;
  if (s && !e) return `${s} — Present`;
  if (!s && e) return `${e}`;
  if (s === e) return `${s}`;
  return `${s} — ${e}`;
}
